<template>
    <div class="p-6 mb-8 bg-white rounded-lg lg:p-8">
        <p class="mb-6 text-xl font-bold text-primary-500">III. Occupation 職業</p>
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-4">
            <div class="space-y-3 col-span-full lg:col-span-6">
                <p class="font-bold text-darkgray-800">1. Job description/仕事内容</p>
                <text-input
                    v-model="item.job_title"
                    id="job-title"
                    type="text"
                    placeholder="Job description/仕事内容"
                    :disabled="disableInputs"
                    :error="errors['occupation.job_title'] ? errors['occupation.job_title'][0] : ''"
                />
            </div>
            <div class="space-y-3 col-span-full lg:col-span-6">
                <p class="font-bold text-darkgray-800">2. Work hours / 労働時間</p>
                <text-input
                    id="days_per_week"
                    type="text"
                    placeholder="Days per week / 週の勤務日数"
                    :disabled="disableInputs"
                    @keypress="onKeypressNumbersOnly"
                    @paste="onPasteNumbersOnly"
                    v-model="item.days_per_week"
                    :maxlength=3
                    :error="errors['occupation.days_per_week'] ? errors['occupation.days_per_week'][0] : ''"
                />
                <text-input
                    v-model="item.hours_per_day"
                    id="work-hours"
                    type="text"
                    placeholder="Hours per day / 1日の勤務時間"
                    @keypress="onKeypressNumbersOnly"
                    @paste="onPasteNumbersOnly"
                    :disabled="disableInputs"
                    :maxlength=3
                    :error="errors['occupation.hours_per_day'] ? errors['occupation.hours_per_day'][0] : ''"
                />
            </div>
        </div>

        <div class="my-8 border-b border-black/[.04]"></div>

        <div class="grid grid-cols-1 mb-10 lg:grid-cols-12 gap-x-8 gap-y-6">
            <div class="col-span-full">
                <p class="mb-4 text-darkgray-800">We will send your results via email to your registered email address. Please check below if you also wish to obtain a hard copy. / 健診結果はご登録いただいているメールアドレスにお送りいたします。ハードコピーをご希望の場合は、以下よりお選びください。</p>
                <div class="grid grid-cols-1 space-y-2 lg:grid-cols-12">
                    <radio-group
                        :options="[
                            { id: 'pick_up', label: 'Pick-up/来院', value: 'pick_up'},
                            { id: 'delivery', label: 'Delivery/配送', value: 'delivery'},
                        ]"
                        name="result_delivery_option"
                        customClass="col-span-6"
                        :is-disabled="disableInputs"
                        v-model="item.result_delivery_option"
                        :error="errors['occupation.result_delivery_option'] ? errors['occupation.result_delivery_option'][0] : ''"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import TextInput from '@/components/inputs/TextInput.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';
import { numberonly } from '@/helpers/NumberHelper'
import { ref } from 'vue';
import { onKeypressNumbersOnly, onPasteNumbersOnly } from '@/helpers/ValidationHelpers';

const props = defineProps({
    form: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: true
    },
    errors: {
        type: Array,
        required: true
    },
})

const item = ref(props.form)

</script>